export default __webpack_public_path__ + "static/media/template14.f218b97a.svg";